/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
const l=(o,a)=>{if(!a)return"unknown";const e=a.BegYear===o.BegYear?.toString()&&a.MakeName===o.MakeName&&a.ModelName===o.ModelName,s=o.SubmodelName&&o.SubmodelName!=="-",r=!!(e&&(!s||a.SubmodelName&&a.SubmodelName===o.SubmodelName)),m=!!(e&&s&&!a.SubmodelName);return r?!0:m?"partial":!1},n=({vehicle:o,truncate:a})=>{const e=`’${o.BegYear.slice(-2)} ${o.ModelName}`,s=`${o.BegYear} ${o.MakeName} ${o.ModelName} ${o.SubmodelName}`;return a?{short:e.slice(0,16)+"…",long:s.slice(0,20)+"…"}:{short:e,long:s}};export{n as f,l as i};
